<template>
	<div id="dont-give-up" class="wrap pt-12">
		<h2 class="sub--title text-center primary--text mt-5 mt-sm-8 mb-2">
			{{ $t('dont-give-up.sub-title') }}
		</h2>
		<h1
			class="main--title text-center mb-12 pb-sm-4"
			v-html="$t('dont-give-up.title')"
		></h1>

		<v-row
			no-gutters
			align="center"
			style="max-width: 900px"
			class="mx-auto pb-sm-11 pb-5"
		>
			<v-col cols="12" sm="4" class="px-2">
				<v-card
					class="point-card mb-9"
					:style="
						language === 'ja' && userDevice === 'desktop'
							? 'min-height:212px'
							: ''
					"
				>
					<img
						style="
							position: absolute;
							top: -25px;
							left: 50%;
							margin-left: -25px;
						"
						src="@/assets/images/don-give-up-point-1.png"
						alt=""
					/>
					<div class="comment" v-html="$t('dont-give-up.card-1')"></div>
				</v-card>
			</v-col>
			<v-col cols="12" sm="4" class="px-2">
				<v-card class="point-card mb-9">
					<img
						style="
							position: absolute;
							top: -25px;
							left: 50%;
							margin-left: -25px;
						"
						src="@/assets/images/don-give-up-point-2.png"
						alt=""
					/>
					<div class="comment" v-html="$t('dont-give-up.card-2')"></div>
				</v-card>
			</v-col>
			<v-col cols="12" sm="4" class="px-2">
				<v-card class="point-card mb-9">
					<img
						style="
							position: absolute;
							top: -25px;
							left: 50%;
							margin-left: -25px;
						"
						src="@/assets/images/don-give-up-point-3.png"
						alt=""
					/>
					<div class="comment" v-html="$t('dont-give-up.card-3')"></div>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	computed: {
		userDevice() {
			return this.$store.getters['userDevice']
		},
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss">
#dont-give-up {
	background-color: #f1f5ff;

	@media screen and (max-width: 600px) {
		.main-title {
			font-size: 28px;
			font-weight: bold;
			letter-spacing: -1.4px;
		}
	}

	.point-card {
		position: relative;
		padding: 52px 20px 48px;
		border-radius: 20px !important;
		box-shadow: 11px 17px 28px 0 rgba(33, 51, 82, 0.18) !important;
		background-color: #fff;
		.comment {
			font-size: 18px;
			font-weight: 500;
			line-height: 1.56;
			letter-spacing: -0.9px;
			text-align: center;
			color: #000;
			margin-bottom: 0;
		}
		.highlight {
			display: inline-block;
			position: relative;
		}
		.highlight::after {
			content: '';
			margin-top: -9px;
			display: block;
			width: 100%;
			height: 6px;
			background-color: #d1dfff;
		}
	}

	@media screen and (max-width: 600px) {
		.point-card {
			max-width: 295px;
			margin: 0 auto;
			padding: 41px 40px 34px;
			border-radius: 10px !important;

			.comment {
				font-family: NotoSansKR;
				font-size: 16px;
				font-weight: 500;
				line-height: 1.56;
				letter-spacing: -0.8px;
			}
		}
	}
}
</style>
